/**
 * Порог «мин. регистраций» раздела «Прототипы»: проект виден, если когорта за период (first_open) >= порога.
 * Тот же предикат — у параметра minRegistrations MCP (server/src/mcp/registry/prototypes.ts).
 */

import React from 'react';

/** Проекты с регистрациями >= порога; порог 0 — без фильтра */
export function filterByMinRegistrations(projects, minRegistrations, getRegistrations) {
  if (!minRegistrations) return projects;
  return projects.filter((project) => Number(getRegistrations(project) || 0) >= minRegistrations);
}

export function HiddenProjectsNote({ hidden, minRegistrations }) {
  if (!minRegistrations || hidden === 0) return null;
  return (
    <p className="text-xs text-muted-foreground">
      Скрыто проектов: {hidden} (меньше {minRegistrations.toLocaleString('ru-RU')} регистраций)
    </p>
  );
}
